import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import constants from './plugins/constants'
import storage from './plugins/storage'
import util from './plugins/util'
import nutrients from './plugins/nutrients'
import units from './plugins/units'
import gender from './plugins/gender'
import i18n from './i18n'
import daySpanVuetify from 'dayspan-vuetify'
import VueAnalytics from 'vue-analytics'
import Ads from 'vue-google-adsense'

import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'dayspan-vuetify/dist/lib/dayspan-vuetify.min.css'

Vue.config.productionTip = false

Vue.use(daySpanVuetify, {
  methods: {
    getDefaultEventColor: () => '#1976d2'
  }
})
Vue.use(storage)
Vue.use(util)
Vue.use(nutrients)
Vue.use(units)
Vue.use(gender)

Vue.use(VueAnalytics, {
  id: 'UA-107855771-7',
  router
})

Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

Vue.prototype.$version = '0.0.27'
Vue.prototype.$constants = constants

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
